import { all, call, put, takeEvery } from "redux-saga/effects";
import API from "../../../Utils/api";
import { MT5_DEPOSIT_WIDTHDRAW } from "../../Action/actionTypes";
import { notifyPromise } from "../../../Utils/Helper";
import { mt5DepositWidthDrawFailure, mt5DepositWidthDrawSuccess } from "../../Action/mt5/mt5DepositWidthdraw";

function* mt5DepositWidthdrawRequest(action) {
  try {

  
    const message=action?.payload?.payload?.paymentRoute==="deposit"?"Deposit in Progress" :"Widthdrawal in Progress"
    const { data } = yield notifyPromise(
      API.post("/mt5-deposit-widthdraw", action?.payload?.payload),
      message
    );

    if (data?.meta?.code === 200) {
     
      yield put(mt5DepositWidthDrawSuccess(data?.data));
      if (action?.payload?.callback) {
 
        yield call(action?.payload?.callback, data);
      }
    } else {
      yield put(mt5DepositWidthDrawFailure());
    }
  } catch (error) {
    yield put(mt5DepositWidthDrawFailure());
  }
}

export function* watchmt5DepositWidthdrawRequestAPI() {
  yield takeEvery(MT5_DEPOSIT_WIDTHDRAW, mt5DepositWidthdrawRequest);
}

export default function* rootSaga() {
  yield all([watchmt5DepositWidthdrawRequestAPI()]);
}
